export default __webpack_public_path__ + "static/media/tshirt1.ea283112.png";